import { Navigate } from 'react-router-dom';

import { useAuth } from '../../../auth/AuthProvider';
import { permissions } from '../../../auth/permissions';
import { MachineCreateForm } from '../components/MachineCreateForm';
import { useMachines } from '../api/useMachines';

export function CreateMachinePage() {
  const auth = useAuth();
  const machines = useMachines();

  if (!auth.can(permissions.machineCreate)) {
    return <Navigate to="/machines" replace />;
  }

  // The first machine is intentionally created inline on the Machines page so the
  // user never enters a machine-scoped shell before a machine actually exists.
  if (!machines.isPending && !machines.isError && (machines.data?.machines.length ?? 0) === 0) {
    return <Navigate to="/machines" replace />;
  }

  return (
    <section className="r42-page r42-form-page">
      <div className="r42-form-heading">
        <div>
          <span className="r42-eyebrow">Machine setup</span>
          <h1>Create machine</h1>
          <p>Add the minimum information Route42 needs to establish a machine workspace. Only the machine name is required.</p>
        </div>
      </div>

      <MachineCreateForm />
    </section>
  );
}
